define('views/parts/feedback/send-feedback-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    'services/api',
    'services/toastr-service',
    // views
    'views/parts/modal/modal',
    'views/modules/feedback/modal/feedback-modal-form'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    API,
    ToastrService,
    // views
    VModal,
    VFeedbackModalForm
) {
    var VSendFeedbackModal = VModal.extend({
        template: '<textarea class="form-control" id="message"></textarea>',

        modal: {
            className: 'send-feedback-modal'
        },

        buttons: function(buttons) {
            return _.extend(buttons, {
                confirm: {
                    label: i18n.t("Save my feedback"),
                    callback: this.onConfirm
                },
            });
        },

        initialize: function(opt) {
            this.options = opt;
            this.modal.title = this.options.subject;
        },

        render: function() {
            this.$el.empty().append(this.template);
            return this.renderModal();
        },

        onConfirm: function() {
            Backbone.ajax({
                method: 'POST',
                url: API.url('feedback'),
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify({
                    subject: this.options.subject,
                    message: this.$el.find('#message').val()
                }),
                success: function() {
                    ToastrService.success('feedback-send-success');
                },
                error: function() {
                    ToastrService.error('feedback-send-error');
                }
            })
        }
    });

    return VSendFeedbackModal;
});

